//================================================================
//  Page: Requests
//================================================================

//  Purpose: This page shows all requests at each stage

//================================================================


// Libraries
import React, { useReducer, useEffect, useContext } from 'react';

// Contexts
import { SetToast } from '../../Library/GlobalContexts';

// Components
import PageComponent from '../../Components/PageComponent/PageComponent';
import TabView from '../../Components/TabView/TabView';

// Tabs
import New from './Tabs/New';
import InProgress from './Tabs/InProgress';
import Rejected from './Tabs/Rejected';
import Completed from './Tabs/Completed';
import Cancelled from './Tabs/Cancelled';
import All from './Tabs/All';

// Functions
import QueryListener from '../../Library/QueryListener';

// Images

// CSS
import './Requests.css';


export default function Requests() {

  //------------------------------------------------------
  //  useContext
  //------------------------------------------------------

  const setToast = useContext(SetToast);

  //------------------------------------------------------
  //  useReducer
  //------------------------------------------------------

  // Used to store the total requests per stage/view
  const [requests, setRequests] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      'newRequests': [],
      'newRequestsFiltered': [],
      'inProgressRequests': [],
      'inProgressRequestsFiltered': [],
      'rejectedRequests': [],
      'rejectedRequestsFiltered': [],
      'completedRequests': [],
      'completedRequestsFiltered': [],
      'cancelledRequests': [],
      'cancelledRequestsFiltered': [],
      'allRequests': [],
      'allRequestsFiltered': [],
    }
  );

  //------------------------------------------------------
  //  useEffects
  //------------------------------------------------------

  // Query Listener
  // - Get all digital requests in each stage
  useEffect(() => {

    const stages = [
      { key: 'newRequests',  status: 'Not Started', additionalFilter: ['assignedto.email', '==', 'Unassigned'] },
      { key: 'inProgressRequests', status: 'In Progress' },
      { key: 'rejectedRequests', status: 'Rejected' },
    ];

    function onLoadChange(documents) {

      // Filter requests
      const requests = {};

      stages.forEach(stage => {
        requests[stage.key] = documents.filter(document => {
          if (stage.additionalFilter) {
            return document.status === stage.status && document[stage.additionalFilter[0]] === stage.additionalFilter[1];
          } else {
            return document.status === stage.status;
          }
        });

      });

      setRequests(requests);

    }

    function onError(error) {

      // Error loading requests
      setToast({
        'type': 'error',
        'message': 'Error loading requests',
      });

      console.log(error);

    }

    const unsubscribe = QueryListener('requests', [
      ['assignmentgroup', '==', 'Demand Management'],
      ['tasktype', '==', 'Digital Request'],
    ], onLoadChange, onLoadChange, onError);

    return () => {
      unsubscribe();
    };

    // eslint-disable-next-line
  }, []);

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <PageComponent
      body={
        <TabView
          defaultView={1}

          //------------------------------------------------------
          //  New
          //------------------------------------------------------

          oneTitle={
            <div className='flex flex-row gap-2'>
              New
              <div className='flex items-center justify-center h-[22px] w-[22px] rounded-full bg-[#006866] text-white text-[12px] font-bold' hidden={requests?.newRequests?.length === 0}>
                {requests?.newRequests?.length}
              </div>
            </div>
          }
          oneRoute={'/requests?view=new'}
          oneContent={
            <New
              requests={requests}
              setRequests={setRequests}
            ></New>
          }

          //------------------------------------------------------
          //  In Progress
          //------------------------------------------------------

          twoTitle={
            <div className='flex flex-row gap-2'>
              In Progress
              <div className='flex items-center justify-center h-[22px] w-[22px] rounded-full bg-[#006866] text-white text-[12px] font-bold' hidden={requests?.inProgressRequests?.length === 0}>
                {requests?.inProgressRequests?.length}
              </div>
            </div>
          }
          twoRoute={'/requests?view=inprogress'}
          twoContent={
            <InProgress
              requests={requests}
              setRequests={setRequests}
            ></InProgress>
          }

          //------------------------------------------------------
          //  Completed
          //------------------------------------------------------

          threeTitle={'Completed'}
          threeRoute={'/requests?view=completed'}
          threeContent={
            <Completed
              requests={requests}
              setRequests={setRequests}
            ></Completed>
          }

          //------------------------------------------------------
          //  Rejected
          //------------------------------------------------------

          fourTitle={
            <div className='flex flex-row gap-2'>
              Rejected
              <div className='flex items-center justify-center h-[22px] w-[22px] rounded-full bg-[#006866] text-white text-[12px] font-bold' hidden={requests?.rejectedRequests?.length === 0}>
                {requests?.rejectedRequests?.length}
              </div>
            </div>
          }
          fourRoute={'/requests?view=rejected'}
          fourContent={
            <Rejected
              requests={requests}
              setRequests={setRequests}
            ></Rejected>
          }

          //------------------------------------------------------
          //  Cancelled
          //------------------------------------------------------

          fiveTitle={'Cancelled'}
          fiveRoute={'/requests?view=cancelled'}
          fiveContent={
            <Cancelled
              requests={requests}
              setRequests={setRequests}
            ></Cancelled>
          }

          //------------------------------------------------------
          // All
          //------------------------------------------------------

          sixTitle={'All'}
          sixRoute={'/requests?view=all'}
          sixContent={
            <All
              requests={requests}
              setRequests={setRequests}
            ></All>
          }

        ></TabView>
      }
    ></PageComponent>
  )
}
